export default (context) => {
    return {
  
      config: {
        pageSize: 40,
        list: false,
        remapRow: (form) => {
          return form
        }
      },
  
      actions: {
        create: true,
        edit: true,
        delete: true,
        print: true,
        export: true,
        search: true
      },

      form: {
        remapOne: (r) => {
          return r
        },
        setValuesBeforePost: (v) => {
          return v
        },
        fields: [
          {
            col: 6,
            name: "name",
            value: "",
            type: "text",
            label: "Nombre",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 6,
            name: "type",
            value: null,
            type: "select",
            label: "Tipo",
            rules: 'required',
            opts: {
              style: 'float-label',
              items: [
                {value: 0, label: "Justificación No recibida"},
                {value: 1, label: "Justificación Recibida"},
                {value: 2, label: "Justificación Aceptada"},
                {value: -1, label: "Justificación Rechazada"}
              ]
            }
          },
          {
            col: 12,
            name: "notify",
            value: false,
            type: "switch",
            label: "Notificar a padres"
          },
          {
            col: 12,
            name: "notifyDelay",
            value: 0,
            type: "number",
            label: "Notificar pasados tantos minutos de horario entrada",
            rules: 'required',
            opts: {
              style: 'float-label'
            },
            renderIf: (ctx) => { return  ctx.state.notify }
          },
          {
            col: 12,
            name: "showInReports",
            value: false,
            type: "switch",
            label: "Mostrar en reportes de notas"
          },
        ]
      },
  
      columns: [
        {
          Header: "ID",
          accessor: "ID"
        },
        {
          Header: "Nombre",
          accessor: "name"
        },
        {
          Header: "Notificar a padres",
          accessor: "notify",
          isBool: true
        },
        {
          Header: "Mostrar en reportes de notas",
          accessor: "showInReports",
          isBool: true
        }
      ]
    }
  }